import Table from '@shared/components/Table';
import { usePersonalFiles } from '../hooks/usePersonalFiles';
import OrgUnitPicker from '../../../../../shared/components/OrgUnitPicker';

export default function PersonalFiles() {
    const tableProps = usePersonalFiles();

    return (
        <Table
            title={tableProps.title}
            searchOptions={tableProps.searchOptions}
            showPagination={true}
            showPageSizeSelector={false}
            columns={tableProps.columns}
            data={tableProps.data}
            loading={tableProps.loading}
            error={tableProps.error}
            pageNumber={tableProps.pageNumber}
            pageSize={tableProps.pageSize}
            sortBy={tableProps.sortBy}
            sortDir={tableProps.sortDir}
            totalElements={tableProps.totalElements}
            totalPages={tableProps.totalPages}
            searchQuery={tableProps.searchQuery}
            searchType={tableProps.searchType}
            setSearchQuery={tableProps.setSearchQuery}
            setSearchType={tableProps.setSearchType}
            setPageSize={tableProps.setPageSize}
            setpageNumber={tableProps.setpageNumber}
            getData={tableProps.getData}
            handleSearchClick={tableProps.handleSearchClick}
            handleSort={tableProps.handleSort}
            handleRowClick={tableProps.handleRowClick}
            showCustomSearch={tableProps.showOrgUnitPicker}
            customSearchComponent={
                tableProps.showOrgUnitPicker ? (
                    <OrgUnitPicker
                        onSelect={tableProps.handleOrgUnitSelect}
                        onCancel={tableProps.handleOrgUnitPickerCancel}
                    />
                ) : null
            }
            searchBarProps={{
                onOrgUnitPickerOpen: tableProps.openOrgUnitPicker,
                orgUnitDisplayLabel: tableProps.selectedOrgUnitLabel,
            }}
        />
    );
}
